// extracted by mini-css-extract-plugin
export default {"images":"MultiQuestion_images__jX6zI","image":"MultiQuestion_image__TpTjx","container":"MultiQuestion_container__HtEHv","text":"MultiQuestion_text__O8W1D"};